import React, { useCallback, useEffect, useState } from 'react';
import s from './s.module.less';
import { Button, Select, message } from 'antd';
import { useRequest } from 'ahooks';
import { getOpsMemberList } from 'api/access';
import { updateOpsAssignee, updateUniprofileAssignee } from 'api/operation';

interface IProps {
    channelId: number;
    providerId: number;
    assignee: string;
    refetch: () => void;
}

type Item = { value: string; label: string, id?:number, firstName?:string };

const Assignee = ({
    channelId,
    providerId,
    assignee,
    refetch,
}: IProps) => {
    const [options, setOptions] = useState<Item[]>([]);
    const [assigneeState, setAssigneeState] = useState<Item>();

    const { data } = useRequest(getOpsMemberList);

    useEffect(() => {
        const res = data?.data?.data || [];
        const opts = res.map((e) => {
            const { gmail, id } = e;
            return {
                ...e,
                value: id,
                label: gmail,
            };
        });
        setOptions(opts);
    }, [data]);

    useEffect(() => {
        const assigneeValue = options.find((e) => e.firstName === assignee);

        if (assigneeValue) {
            setAssigneeState(assigneeValue);
        }
    }, [assignee, options]);

    const handleSaveAssignee = useCallback(async () => {
        if (assigneeState) {
            const { id, firstName } = assigneeState;
            const isUniprofile = `${channelId}` === '-1';
            const fn = isUniprofile ? updateUniprofileAssignee : updateOpsAssignee;
            const requestParam:any = {
                providerId,
                assignee: firstName!,
                assigneeUid: id!,
            };
            if (!isUniprofile) {
                requestParam.channelId = channelId;
            }
            const res = await fn(requestParam);

            if (res?.error) {
                message.error(res.error);
            } else {
                message.success('Assigned successfully');
                refetch();
            }
        }
    }, [assigneeState, channelId, providerId]);

    const handleChange = useCallback((value: number) => {
        const assigneeValue = options.find((e) => e.id === value);

        if (assigneeValue) {
            setAssigneeState(assigneeValue);
        }
    }, [options]);

    return (
        <div className={s.wrap}>
            <div className={s.title}>Assignee</div>
            <Select
                value={assigneeState?.id}
                showSearch
                placeholder="Select a person"
                optionFilterProp="children"
                style={{ width: 376 }}
                onChange={handleChange}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={options}
            />
            {/* <AutoComplete
                options={options}
                style={{ width: 376 }}
                onSearch={handleSearch}
            > */}
            {/* </AutoComplete> */}
            <div className={s.btns}>
                <Button type="primary" onClick={handleSaveAssignee}>Save</Button>
            </div>
        </div>
    );
};

export default Assignee;
